"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Radio = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Radio = function Radio(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      field = _ref.field,
      flexDirection = _ref.flexDirection;
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: field.input.name,
    style: {
      display: 'flex',
      flexDirection: flexDirection
    }
  }, label, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, field.input, {
    id: field.input.name,
    disabled: disabled,
    "data-testid": "HTMLRadio"
  })));
};

exports.Radio = Radio;
var _default = Radio;
exports.default = _default;
Radio.propTypes = {
  // passed down from RFFField
  field: _propTypes.default.shape({
    input: _propTypes.default.shape({
      name: _propTypes.default.string
    })
  }),

  /**
   * If true, the input element will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * label for input
   */
  label: _propTypes.default.string,

  /**
   * The flex-direction CSS property sets how flex items are placed in the flex container defining
   the main axis and the direction (normal or reversed).
   * https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction
   */
  flexDirection: _propTypes.default.string
};
Radio.defaultProps = {
  disabled: false,
  flexDirection: 'column',
  field: {},
  label: ''
};